import styled from 'styled-components';

export const SlideContainer = styled.div`
margin: 0.8em 3.1em; 
height: 36px; 
width: 350px; 
background-color: #CDD6E5;
box-shadow: rgb(167 168 169) 3px 3px 6px 0px inset, rgb(220 220 220) -3px -3px 6px 1px inset;
border-radius: 5px; 
position: relative;

.slider {
    height: 100%; 
    width: 85%; 
    border-radius: 5px;
    display: grid; 
    place-content: center; 
    cursor: pointer; 
    box-shadow: rgba(0, 0, 0, 0.15) 3px 3px 4px;
    position: absolute;
}`;